import { useQuery } from '@tanstack/react-query';

import { listRegistrationTokens } from '~/services/AgentHub/AgentService';

const FIVE_MINUTES = 5 * 60 * 1000;

interface UseListRegistrationTokensParams {
  agentId: string | undefined;
  page: number;
  pageSize: number;
  status: string | undefined;
}

export function useListRegistrationTokens({ agentId, status, page, pageSize }: UseListRegistrationTokensParams) {
  return useQuery({
    queryKey: ['registration-tokens', agentId, page, pageSize, status],
    queryFn: async () => {
      return await listRegistrationTokens(agentId, {
        page: page.toString(),
        pageSize: pageSize.toString(),
      });
    },
    enabled: !!agentId,
    staleTime: FIVE_MINUTES,
  });
}
